export const types = {
  SET_ITEMS: 'SET_ITEMS',
};

export const mutations = {
  [types.SET_ITEMS] (state, items) {
    state.items = items;
  },
};
